
const getTotalPagesCount = (totalItemsCount, perPage) => {
  return Math.ceil(totalItemsCount / perPage);
}

export default getTotalPagesCount;